<template>
<div class="chapter">
<div class="inner_page">
<p class="P_x-1-PART-title-1"><span><a href="#/section0005">Part 1</a></span></p>
<p class="P_x-2-PART-head-1"><span> </span></p>
<p class="P_x-2-PART-head-1"><span>Setting the Scene</span></p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph">The scene was set in Dallas long before John Kennedy visited there on November 22, 1963. During the immediate post-World War II era, the country had struggled as it tried to find and identify its Cold War posture. We had reached a consensus to have a strong and united front to combat the Soviet Union.</p>
<p class="P_Basic-Paragraph">We also tried to cope with a new fear, a fear that the world could destroy itself. Americans worried about a world-ending catastrophe if the country wasn’t vigilant enough or that it may also occur if we provoked a confrontation that would lead to a most different kind of war.</p>
<p class="P_Basic-Paragraph">America turned to charismatic leaders. Amid nuclear nightmares, people had the strongest need to feel safe.</p>
<p class="P_Basic-Paragraph">The country looked to John Kennedy and others to be respected father-figures who somehow had the wisdom to make all the right decisions. Then maybe the nightmares could all go away.</p>
<p class="P_Basic-Paragraph">Instead, a living nightmare unfolded in Dallas.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0008.vue?57d61f7b